import { URITypeMap } from '../../../enums/uri_type';
import { URIParticle } from '../../../enums/uri_particle';
import { createParserDefinition } from '../helpers';
import * as factory from '../../../factories';
const [declareUserURIParser, UserURIParsers] = createParserDefinition();
declareUserURIParser(URITypeMap.PLAYLIST, (context, _format, { username }) => {
    return factory.playlistURI(username, context.getBase62IdComponent());
});
declareUserURIParser(URITypeMap.FOLDER, (context, _format, { username }) => {
    return factory.folderURI(username, context.getIdComponent());
});
declareUserURIParser(URITypeMap.COLLECTION_TRACK_LIST, (context, _format, { username }) => {
    return factory.collectionTrackListURI(username, context.getIdComponent());
});
declareUserURIParser(URITypeMap.COLLECTION, (context, _format, { username }) => {
    const collectionItemType = context.getNextComponent();
    if (collectionItemType === URITypeMap.ALBUM) {
        const id = context.getIdComponent();
        if (context.getNextComponent() === 'missing') {
            return factory.collectionMissingAlbumURI(username, id);
        }
        return factory.collectionAlbumURI(username, id);
    }
    if (collectionItemType === URITypeMap.ARTIST) {
        return factory.collectionArtistURI(username, context.getIdComponent());
    }
    return factory.collectionURI(username, collectionItemType);
});
declareUserURIParser(URITypeMap.STARRED, (_context, _format, { username }) => {
    return factory.starredURI(username);
});
declareUserURIParser(URITypeMap.FOLLOWERS, (_context, _format, { username }) => {
    return factory.followersURI(username);
});
declareUserURIParser(URITypeMap.FOLLOWING, (_context, _format, { username }) => {
    return factory.followingURI(username);
});
declareUserURIParser(URIParticle.TOP, (context, _format, { username }) => {
    return factory.userToplistURI(username, context.getNextRequiredComponent());
});
declareUserURIParser(URITypeMap.INBOX, (_context, _format, { username }) => {
    return factory.inboxURI(username);
});
declareUserURIParser(URITypeMap.ROOTLIST, (_context, _format, { username }) => {
    return factory.rootlistURI(username);
});
declareUserURIParser(URITypeMap.PUBLISHED_ROOTLIST, (_context, _format, { username }) => {
    return factory.publishedRootlistURI(username);
});
declareUserURIParser(URITypeMap.TOPLIST, (_context, _format, { username }) => {
    // legacy toplist
    return factory.userTopTracksURI(username);
});
declareUserURIParser(URITypeMap.LIBRARY, (context, _format, { username }) => {
    return factory.libraryURI(username, context.getNextComponent());
});
export { UserURIParsers };
//# sourceMappingURL=user.js.map